document.addEventListener('DOMContentLoaded', () => {
  const module = document.querySelector<HTMLElement>('.js-rlx-wgf');
  if (!module) return;

  const sidebar = module.querySelector<HTMLElement>('.js-rlx-wgf-sidebar')!;
  const overlay = document.querySelector<HTMLElement>('.js-rlx-wgf-overlay')!;
  const openBtn = module.querySelector<HTMLButtonElement>('.js-rlx-wgf-open')!;
  const closeBtn = module.querySelector<HTMLButtonElement>('.js-rlx-wgf-close')!;
  const confirmBtn = module.querySelector<HTMLButtonElement>('.js-rlx-wgf-confirm')!;
  const sortSelect = module.querySelector<HTMLSelectElement>('.js-rlx-wgf-sort')!;
  const grid = module.querySelector<HTMLElement>('.js-rlx-wgf-grid')!;
  const noResults = module.querySelector<HTMLElement>('.js-rlx-wgf-no-results')!;
  const countMobile = module.querySelector<HTMLElement>('.js-rlx-wgf-count')!;
  const countDesktop = module.querySelector<HTMLElement>('.js-rlx-wgf-count-desktop');
  const loadMoreWrap = module.querySelector<HTMLElement>('.js-rlx-wgf-load-more-wrap')!;
  const loadMoreBtn = module.querySelector<HTMLButtonElement>('.js-rlx-wgf-load-more')!;

  const PAGE_SIZE = 24;
  let shownCount = PAGE_SIZE;

  // All cards — used only for reset reference
  const allCards = Array.from(module.querySelectorAll<HTMLElement>('.js-rlx-wgf-card'));
  const originalOrder = [...allCards];

  // ── Mobile sidebar open/close ─────────────────────────────

  const openSidebar = () => {
    sidebar.classList.add('is-open');
    sidebar.removeAttribute('aria-hidden');
    overlay?.classList.add('is-visible');
    openBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  };

  const closeSidebar = () => {
    sidebar.classList.remove('is-open');
    sidebar.setAttribute('aria-hidden', 'true');
    overlay?.classList.remove('is-visible');
    openBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  };

  openBtn?.addEventListener('click', openSidebar);
  closeBtn?.addEventListener('click', closeSidebar);
  confirmBtn?.addEventListener('click', closeSidebar);
  overlay?.addEventListener('click', closeSidebar);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && sidebar.classList.contains('is-open')) closeSidebar();
  });

  // ── Filter group collapse/expand ──────────────────────────

  module.querySelectorAll<HTMLButtonElement>('.js-rlx-wgf-group-toggle').forEach((toggle) => {
    const panel = toggle.nextElementSibling as HTMLElement;

    toggle.addEventListener('click', () => {
      const isExpanded = toggle.getAttribute('aria-expanded') !== 'false';
      const icon = toggle.querySelector<HTMLElement>('.rlx-wgf__group-icon')!;

      toggle.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
      panel.classList.toggle('is-collapsed', isExpanded);
      icon.textContent = isExpanded ? '+' : '−';
    });
  });

  // ── Collection text-button filters ───────────────────────

  module.querySelectorAll<HTMLButtonElement>('.js-rlx-wgf-collection').forEach((btn) => {
    btn.addEventListener('click', () => {
      const isActive = btn.getAttribute('aria-pressed') === 'true';
      btn.setAttribute('aria-pressed', isActive ? 'false' : 'true');
      btn.classList.toggle('is-active', !isActive);
      shownCount = PAGE_SIZE;
      applyFilters();
    });
  });

  // ── Filtering ─────────────────────────────────────────────

  const getActiveFilters = (): Record<string, string[]> => {
    const active: Record<string, string[]> = {};

    const activeCols = Array.from(
      module.querySelectorAll<HTMLButtonElement>('.js-rlx-wgf-collection[aria-pressed="true"]')
    ).map((btn) => btn.dataset.filterValue!);
    if (activeCols.length) active.collection = activeCols;

    module.querySelectorAll<HTMLInputElement>('.js-rlx-wgf-checkbox:checked').forEach((cb) => {
      const type = cb.dataset.filterType!;
      const value = cb.dataset.filterValue!;
      if (!active[type]) active[type] = [];
      active[type].push(value);
    });

    return active;
  };

  const cardMatchesFilters = (card: HTMLElement, filters: Record<string, string[]>): boolean => {
    for (const [type, values] of Object.entries(filters)) {
      if (!values.length) continue;

      let cardValues: string[] = [];
      switch (type) {
        case 'collection':
          cardValues = card.dataset.collection ? [card.dataset.collection] : [];
          break;
        case 'size':
          cardValues = card.dataset.size ? [card.dataset.size] : [];
          break;
        case 'material':
          cardValues = card.dataset.materials ? card.dataset.materials.split('||').filter(Boolean) : [];
          break;
        case 'dial':
          cardValues = card.dataset.dials ? card.dataset.dials.split('||').filter(Boolean) : [];
          break;
        case 'price':
          cardValues = card.dataset.price ? [card.dataset.price] : [];
          break;
      }

      if (!values.some((v) => cardValues.includes(v))) return false;
    }
    return true;
  };

  const applyFilters = () => {
    const filters = getActiveFilters();

    // Use current DOM order (respects any active sort)
    const orderedCards = Array.from(grid.querySelectorAll<HTMLElement>('.js-rlx-wgf-card'));
    const matching = orderedCards.filter((card) => cardMatchesFilters(card, filters));

    orderedCards.forEach((card) => card.classList.add('is-hidden'));
    matching.slice(0, shownCount).forEach((card) => card.classList.remove('is-hidden'));

    noResults.hidden = matching.length > 0;

    if (loadMoreWrap) loadMoreWrap.hidden = matching.length <= shownCount;

    const total = Object.values(filters).reduce((sum, arr) => sum + arr.length, 0);
    if (total > 0) {
      countMobile.textContent = String(total);
      countMobile.hidden = false;
      if (countDesktop) { countDesktop.textContent = String(total); countDesktop.hidden = false; }
    } else {
      countMobile.hidden = true;
      if (countDesktop) countDesktop.hidden = true;
    }
  };

  module.querySelectorAll<HTMLInputElement>('.js-rlx-wgf-checkbox').forEach((cb) => {
    cb.addEventListener('change', () => {
      shownCount = PAGE_SIZE;
      applyFilters();
    });
  });

  // ── Load more ─────────────────────────────────────────────

  loadMoreBtn?.addEventListener('click', () => {
    shownCount += PAGE_SIZE;
    applyFilters();
  });

  // ── Reset ─────────────────────────────────────────────────

  module.querySelectorAll<HTMLButtonElement>('.js-rlx-wgf-reset').forEach((resetBtn) => {
    resetBtn.addEventListener('click', () => {
      module.querySelectorAll<HTMLInputElement>('.js-rlx-wgf-checkbox').forEach((cb) => {
        cb.checked = false;
      });
      module.querySelectorAll<HTMLButtonElement>('.js-rlx-wgf-collection').forEach((colBtn) => {
        colBtn.setAttribute('aria-pressed', 'false');
        colBtn.classList.remove('is-active');
      });
      sortSelect.value = 'featured';
      originalOrder.forEach((card) => grid.appendChild(card));
      shownCount = PAGE_SIZE;
      applyFilters();
    });
  });

  // ── Sort ──────────────────────────────────────────────────

  sortSelect?.addEventListener('change', () => {
    const value = sortSelect.value;

    if (value === 'featured') {
      originalOrder.forEach((card) => grid.appendChild(card));
    } else {
      const sorted = [...allCards].sort((a, b) => {
        const pa = parseFloat(a.dataset.rawPrice || '0');
        const pb = parseFloat(b.dataset.rawPrice || '0');
        return value === 'price-asc' ? pa - pb : pb - pa;
      });
      sorted.forEach((card) => grid.appendChild(card));
    }

    shownCount = PAGE_SIZE;
    applyFilters();
  });

  // ── Initial render ────────────────────────────────────────
  applyFilters();
});
